import { CHATBOT_CONTACT_PATHS, chatbotMessages } from './messages';

export const CHATBOT_OPEN_EVENT = 'iskra-chatbot-open';

export const CHATBOT_CONTACT_EMAIL = 'info@iskra.cat';

export const DEFAULT_CHATBOT_ASSISTANT_ID = process.env.RAZZLE_CHATBOT_ASSISTANT_ID || '1';

export const DEFAULT_QUALITY_CHECK_STAGES = [
  {
    start: 0,
    end: 100,
    label: '',
    color: 'black',
  },
];

const clientSideRateLimitHits = [];
const CLIENT_SIDE_WINDOW_MS = 60 * 1000;

const BLOCKED_PATTERNS = [/\b(hack|hacker|crack|password|malware|phishing|ddos|illegal|drug|weapon|porn|violence)\b/i];

const normalizeText = (text = '') =>
  text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const isChatbotEnabled = () => process.env.RAZZLE_CHATBOT_ENABLED;

export const isChatbotModerationEnabled = () => process.env.RAZZLE_CHATBOT_ENABLE_MODERATION !== 'false';

export const getChatbotRateLimit = () => {
  const limit = parseInt(process.env.RAZZLE_CHATBOT_RATE_LIMIT || '10', 10);

  return Number.isFinite(limit) && limit > 0 ? limit : 0;
};

export const getChatbotContactPath = (locale = 'ca') => CHATBOT_CONTACT_PATHS[locale] || CHATBOT_CONTACT_PATHS.ca;

export const normalizeSuggestionItems = (items = []) =>
  items
    .map((item) => {
      if (typeof item === 'string') {
        return item;
      }

      if (item && typeof item === 'object') {
        return item.text || item.label || item.message || item.name || '';
      }

      return '';
    })
    .filter(Boolean);

export const getChatbotModerationMessage = (intl) =>
  intl.formatMessage(chatbotMessages.moderationMessage, {
    email: CHATBOT_CONTACT_EMAIL,
    contactPath: getChatbotContactPath(intl?.locale),
  });

export const getChatbotRateLimitMessage = (intl) =>
  intl.formatMessage(chatbotMessages.rateLimitMessage, {
    limit: getChatbotRateLimit() || 10,
  });

export const isIskraRelated = (question = '') => {
  if (!isChatbotModerationEnabled()) {
    return true;
  }

  const trimmedQuestion = question.trim();
  if (!trimmedQuestion) {
    return false;
  }

  if (trimmedQuestion.length > 2000) {
    return false;
  }

  const normalizedQuestion = normalizeText(trimmedQuestion);

  return !BLOCKED_PATTERNS.some((pattern) => pattern.test(normalizedQuestion));
};

export const canSendChatbotMessage = () => {
  const limit = getChatbotRateLimit();

  if (!limit) {
    return true;
  }

  const now = Date.now();

  while (clientSideRateLimitHits.length && now - clientSideRateLimitHits[0] > CLIENT_SIDE_WINDOW_MS) {
    clientSideRateLimitHits.shift();
  }

  if (clientSideRateLimitHits.length >= limit) {
    return false;
  }

  clientSideRateLimitHits.push(now);
  return true;
};

export const dispatchChatbotOpen = (question = '') => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(CHATBOT_OPEN_EVENT, {
      detail: { question },
    }),
  );
};
